import React, { memo, FunctionComponent } from "react";
import { UncontrolledAlert as BootstrapUncontrolledAlert } from "reactstrap";

type Props = {
  children: React.ReactNode;
  toggle?: any;
  isOpen?: boolean;
  color:
    | "primary"
    | "secondary"
    | "success"
    | "danger"
    | "warning"
    | "info"
    | "light"
    | "dark";
    onClose?: () => void,
};

const UncontrolledAlert: FunctionComponent<Props> = ({ ...props }) => {
  return <BootstrapUncontrolledAlert {...props} />;
};

export default memo(UncontrolledAlert);
